import React from "react";

import Event from "venuescanner-js/react/components/VirtualEvents/components/Event";

const EventsList = (props) => {
  const { category, setIsFormOpen } = props;
  const items = category.events.map((event, index) => (
    <Event
      key={event.name + index}
      event={event}
      setIsFormOpen={setIsFormOpen}
    />
  ));

  return <div className="virtual-events-list">{items}</div>;
};

export default EventsList;
